import AlertsApi from "../../../api/alerts-api";
import { AlertTypes } from "../../../constants/alert_types";

export default {
  name: "ConfirmModal",

  props: {
    alert: Object,
    isModalOpen: Boolean,
    reload: Function,
    modalName: String,
    reaction: String
  },

  data() {
    return {
      date: this.$moment(),
      notes: null,

      errors: {},
      serverError: null
    };
  },
  computed: {
    hasDateInput: function () {
      return [AlertTypes.Heat, AlertTypes.RepeatHeat, AlertTypes.Calving].includes(this.alert.type)
    }
  },
  methods: {
    validate() {
      this.errors = {};

      if (this.hasDateInput) {
        if (this.$refs.reactionTimePicker.error) {
          return false;
        }
      }

      if (Object.keys(this.errors).length > 0) {
        return false;
      }
      return true;
    },
    async save() {
      // Validate form data before save
      const isValidForm = this.validate();
      if (!isValidForm) return;

      // Define the data to send
      const dataToSend = {
        confirmation: this.reaction,
        alert_time: this.$moment(this.date).format(),
        notes: this.notes && this.notes !== "" ? this.notes : undefined
      };

      // Set loading and wait for data to be sent and response to be returned.
      const response = await AlertsApi.post(this.alert.id, dataToSend)

      // Handle response
      if (response.status === 200) {
        // Success: close and reload
        this.reload();
        this.close();
      } else if (response.status === 400) {
        // Failed: Invalid request
        if (typeof response.data === 'object')
          // swagger error (unreadable)
          this.serverError = {
            error: 'Bad request',
            message: 'Invalid url'
          };
        else
          this.serverError = {
            error: 'Bad request',
            message: response.data
          };

      } else {
        // Failed: server error
        this.serverError = {
          error: 'An error occured',
          message: 'Something went wrong'
        }
      }
    },
    close() {
      this.$emit("close");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/reaction/reaction.js